module.exports = __webpack_public_path__ + "static/media/logo.2913198b.svg";